export const mutations = {
  STORE_PETTYCASHES(state, pettycashes) {
    state.pettycashes = pettycashes;
  }
};
export default mutations;



// WEBPACK FOOTER //
// ./src/vuex/modules/pettycashes/mutations.js